import { render } from "./TechnicalDetails.vue?vue&type=template&id=1813cc05&scoped=true"
import script from "./TechnicalDetails.vue?vue&type=script&lang=js"
export * from "./TechnicalDetails.vue?vue&type=script&lang=js"

import "./TechnicalDetails.vue?vue&type=style&index=0&id=1813cc05&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1813cc05"]])

export default __exports__